import { addScript } from "../../../bundles/helpers/add-script";
(async () => {
	if (!window.Swiper) await addScript(PUBLIC_PATH + 'vendor/swiper.vendor.js');
	$('.breadcrumb_swiper').each(function() {
		let $this = $(this);
		let delay = $this.data('delay');
		let api = new Swiper(this, {
			slidesPerView: 'auto',
			spaceBetween: 0,
			freeMode: true,
			freeModeMomentum: false,
			autoplay: delay && {
				delay: delay,
			},
		});
		$this.data('swiper', api);
	});
})();

